/**
 * Every store builds its own axios instance, so the device header and the
 * "this computer is not approved" handling are installed once, here, by wrapping
 * axios.create. Import this before any store (main.ts does, first).
 */
import axios from 'axios'
import { getDeviceId } from '@/utils/device'

export const BLOCKED_PATH = '/device-blocked'
export const FORBIDDEN_EVENT = 'api:forbidden'

export function installDeviceHeader() {
  const create = axios.create.bind(axios)
  ;(axios as any).create = (config?: any) => {
    const instance = create(config)
    instance.interceptors.request.use((request) => {
      request.headers.set('X-Device-Id', getDeviceId())
      // who is asking, so the server's activity log can name the user
      try {
        const ticket = localStorage.getItem('authTicket')
        if (ticket && !request.headers.has('X-Auth-Ticket')) request.headers.set('X-Auth-Ticket', ticket)
      } catch {
        /* storage can be unavailable */
      }
      return request
    })
    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        // The ticket is missing, expired, logged out or its user was blocked: sign in again.
        // (A wrong password is a 200 with status 'fail', so this is never the login call.)
        if (error?.response?.status === 401) {
          try {
            for (const key of ['authTicket', 'authUser', 'authRoles']) localStorage.removeItem(key)
          } catch {
            /* storage can be unavailable */
          }
          if (window.location.pathname !== '/login') window.location.href = '/login'
        }
        // The role may read but not change this data (a device refusal has its own header)
        if (error?.response?.status === 403 && !error.response.headers?.['x-device-status']) {
          window.dispatchEvent(new CustomEvent(FORBIDDEN_EVENT, { detail: String(error.response.data || '') }))
        }
        const reason = error?.response?.headers?.['x-device-status']
        if (reason && error.response?.status === 403) {
          try {
            sessionStorage.setItem('device_block_reason', String(reason))
            sessionStorage.setItem('device_block_message', String(error.response.data || ''))
          } catch {
            /* storage can be unavailable */
          }
          if (window.location.pathname !== BLOCKED_PATH) window.location.href = BLOCKED_PATH
        }
        return Promise.reject(error)
      }
    )
    return instance
  }
}

installDeviceHeader()
